import { defineMessages } from 'react-intl';

export default defineMessages({
    flexAlertMessage: {
        id: 'wmic-pe-capability-gateway-common-react.FlexAlertMessage.Review Flex Percentage - Flex Percentage is adjusted based on the latest Credit Score Information',
        defaultMessage: 'Review Flex Percentage - Flex Percentage is adjusted based on the latest Credit Score Information'
    },
});
